/* eslint-disable */

import * as moment from 'moment';
import { storage } from "../storage";
import { aliensTypes, upgrades, achievements, shipsTypes2 } from "../staticData";
import Alien from "../models/Alien";
import config from '../set_config.json'

export function stringNumber(num, trimZeroes = false) {
    const str = String(num);
    // const str = String(Math.floor(num));
    let baseAmount = 0;
    let volumeType = "";

    const numsArray = ["K", "M", "B", "t", "q", "Q", "s", "S", "o", "n"]
    for (let i = 4; i <= numsArray.length * 3 + 1; i += 3) {
        if (str.length >= i && str.length <= i + 2) {
            baseAmount = Math.abs(str.length - i) + 1;
            const ind = ((i - 1) / 3) - 1
            volumeType = numsArray[ind];
            break;
        }
    }

    if (volumeType) {
        const leftNum = str.substring(0, baseAmount);
        if (trimZeroes) {
            const rightNumTmp = str.substring(baseAmount, baseAmount + 3);
            const floatNum = leftNum + "." + rightNumTmp;
            const finalNum = parseFloat(Number(floatNum).toFixed(3))
            return finalNum + volumeType;
        } else {
            const rightNum = str.substring(baseAmount, baseAmount + 3);
            return leftNum + "." + rightNum + volumeType;
        }
    }
    return str;
}
export function init(totalEarningPerSec) {
    // storage.clicksPerSec = 0
    // storage.sessionID = window["sessionID"]

    for (let i = 0; i < aliensTypes.length; i++) {
        storage.ALIENS_OWNED[aliensTypes[i].name] = new Alien(aliensTypes[i]);
        storage.ALIENS_OWNED[aliensTypes[i].name].name = aliensTypes[i].name;
    }

    for (const name in upgrades) {
        if (name !== 'alienBoost')
            storage.UPGRADES_LVLS[name] = 0
        else {
            storage.UPGRADES_LVLS[name] = {}
            for (let i = 0; i < aliensTypes.length; i++) {
                storage.UPGRADES_LVLS[name][aliensTypes[i].id] = 0
            }
        }
    }

    for (const name in achievements) {
        storage.ACHIEVEMENTS[name] = 0
    }

    // for (const ship in shipsTypes2) {
    //     if (shipsTypes2[ship].type && shipsTypes2[ship].type === 'default') {
    //         storage.SHIP_OWNED[ship] = 1
    //         storage.CURRENT_SHIP = ship
    //     }
    //     else storage.SHIP_OWNED[ship] = 0
    // }
    // storage.SHIP_OWNED['spacebar'] = 1
    // let storedData = localStorage.getItem("space_bar_clicker");
    // console.log('is it', config.isTest)
    let storedData = !config.isTest ? localStorage.getItem("space_bar_clicker") : '{"ALIENS_OWNED":{"Just Jelly":{"amount":1,"id":1,"price":50,"baseEarn":1,"name":"Just Jelly","imgSrc":"alien1"},"Happy Jelly":{"amount":0,"id":2,"price":500,"baseEarn":5,"name":"Happy Jelly","imgSrc":"alien2"},"Crying Jelly":{"amount":0,"id":3,"price":5000,"baseEarn":100,"name":"Crying Jelly","imgSrc":"alien3"},"Wimpy Jelly":{"amount":0,"id":4,"price":50000,"baseEarn":250,"name":"Wimpy Jelly","imgSrc":"alien4"},"Jolly Jelly":{"amount":0,"id":5,"price":100000,"baseEarn":500,"name":"Jolly Jelly","imgSrc":"alien5"},"Grumpy Jelly":{"amount":0,"id":6,"price":350000,"baseEarn":750,"name":"Grumpy Jelly","imgSrc":"alien6"},"Lovely Jelly":{"amount":0,"id":7,"price":1000000,"baseEarn":1000,"name":"Lovely Jelly","imgSrc":"alien7"},"Goofy Jelly":{"amount":0,"id":8,"price":2500000,"baseEarn":1250,"name":"Goofy Jelly","imgSrc":"alien8"},"Snarky Jelly":{"amount":0,"id":9,"price":10000000,"baseEarn":2000,"name":"Snarky Jelly","imgSrc":"alien9"},"Laughy Jelly":{"amount":0,"id":10,"price":50000000,"baseEarn":5000,"name":"Laughy Jelly","imgSrc":"alien10","minGalaxyInd":20},"Amazed Jelly":{"amount":0,"id":11,"price":1000000000,"baseEarn":10000,"name":"Amazed Jelly","imgSrc":"alien11","minGalaxyInd":25},"Sleepy Jelly":{"amount":0,"id":12,"price":5000000000,"baseEarn":15000,"name":"Sleepy Jelly","imgSrc":"alien12","minGalaxyInd":30}},"UPGRADES_LVLS":{"ships":5,"aliensDiscount":5,"extraBoost":3,"alienBoost":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0}},"SHIP_LEVEL":3,"GALAXY_IND": 6,"CLICK_PER_SEC":0,"CLICK_PER_MIN":0,"CLICKS_ALL":0,"COINS":"9300000000000000000002","PINK_COINS":100000,"BLACK_COINS":1000,"LAST_AWARD_TIME":"2023-11-20T11:28:07.839Z","MAX_CLICKS":0,"AUDIO_ON":true,"MUSIC_ON":true,"VERSION":2,"RESET":false}'
    // let storedData = '{"ALIENS_OWNED":{"Just Jelly":{"amount":5,"id":1,"price":25,"baseEarn":1,"name":"Just Jelly","imgSrc":"alien1","isBoostable":true},"Happy Jelly":{"amount":1,"id":2,"price":200,"baseEarn":5,"name":"Happy Jelly","imgSrc":"alien2","isBoostable":false},"Crying Jelly":{"amount":1,"id":3,"price":5000,"baseEarn":100,"name":"Crying Jelly","imgSrc":"alien3","isBoostable":false},"Wimpy Jelly":{"amount":0,"id":4,"price":50000,"baseEarn":250,"name":"Wimpy Jelly","imgSrc":"alien4","isBoostable":true},"Jolly Jelly":{"amount":0,"id":5,"price":100000,"baseEarn":500,"name":"Jolly Jelly","imgSrc":"alien5","isBoostable":false},"Grumpy Jelly":{"amount":0,"id":6,"price":350000,"baseEarn":750,"name":"Grumpy Jelly","imgSrc":"alien6","isBoostable":true},"Lovely Jelly":{"amount":0,"id":7,"price":1000000,"baseEarn":1000,"name":"Lovely Jelly","imgSrc":"alien7","isBoostable":false},"Goofy Jelly":{"amount":0,"id":8,"price":2500000,"baseEarn":1250,"name":"Goofy Jelly","imgSrc":"alien8","isBoostable":true},"Snarky Jelly":{"amount":0,"id":9,"price":10000000,"baseEarn":2000,"name":"Snarky Jelly","imgSrc":"alien9","isBoostable":false},"Laughy Jelly":{"amount":0,"id":10,"price":50000000,"baseEarn":5000,"name":"Laughy Jelly","imgSrc":"alien10","minGalaxyInd":20,"isBoostable":false},"Amazed Jelly":{"amount":0,"id":11,"price":1000000000,"baseEarn":10000,"name":"Amazed Jelly","imgSrc":"alien11","minGalaxyInd":25,"isBoostable":false},"Sleepy Jelly":{"amount":0,"id":12,"price":5000000000,"baseEarn":15000,"name":"Sleepy Jelly","imgSrc":"alien12","minGalaxyInd":30,"isBoostable":true}},"UPGRADES_LVLS":{"ships":0,"aliensDiscount":0,"extraBoost":0,"alienBoost":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0}},"SHIP_OWNED":{"spacebar":1,"stick":1,"banana":1,"beans":1,"chocolate":1,"cookie":1,"wine":1,"corn":1,"flipflop":1,"hotdog":1,"sandwich":1},"CURRENT_SHIP":"spacebar","ACHIEVEMENTS":{"Just Jelly":0,"Grumpy Jelly":0,"Lovely Jelly":0,"Amazed Jelly":0,"Sleepy Jelly":0,"RICHNESS":0,"CLICKS_ALL":0,"MAXED_SPEED":0},"GALAXY_IND":0,"CLICKS_ALL":235,"MAXED_SPEED":9,"BOOST_ON":true,"BOOST_NUM":2,"NEXT_BOOST_TIME":"2024-01-03T13:10:54.673Z","COINS":"170253","PINK_COINS":0,"BLACK_COINS":0,"LAST_AWARD_TIME":"2024-01-03T13:54:59.172Z","AUDIO_ON":true,"MUSIC_ON":false,"VERSION":3,"RESET":false,"MAX_CLICKS":0,"CLICK_PER_MIN":0,"CLICK_PER_SEC":0,"GLOW_ON":false}'

    if (storedData !== null && typeof storedData !== "undefined" && storedData.length > 0) {
        // console.log('STOTAGE', storedData)
        storedData = JSON.parse(storedData);

        for (const key in storage) {
            if (key in storedData && key !== 'ALIENS_OWNED' && key !== 'ACHIEVEMENTS' && key !== 'SHIP_OWNED') {
                // console.log('COMPERE', key, storage[key], storedData[key])
                storage[key] = storedData[key]
            }
        }


        for (const ship in shipsTypes2) {
            if (!storedData.SHIP_OWNED) storedData.SHIP_OWNED = {}
            if (storedData.SHIP_OWNED[ship])
                storage.SHIP_OWNED[ship] = storedData.SHIP_OWNED[ship]
            else if (shipsTypes2[ship].type && shipsTypes2[ship].type === 'default')
                storage.SHIP_OWNED[ship] = 1
            // else storage.SHIP_OWNED[ship] = 0
        }


        if (!storedData.VERSION || storedData.VERSION < storage.VERSION) {
            storage.RESET = true
        }
        storage.COINS = storedData.COINS ? BigInt(Math.floor(storedData.COINS)) : storage.COINS;
        // console.log('CURRENT_SHIP', storage.CURRENT_SHIP)
        if (storedData.ALIENS_OWNED)
            for (const [__, value] of Object.entries(storedData.ALIENS_OWNED)) {
                if (storage.ALIENS_OWNED[value.name])
                    storage.ALIENS_OWNED[value.name].amount = value.amount
            };

        if (storedData.ACHIEVEMENTS)
            for (const [key, __] of Object.entries(storage.ACHIEVEMENTS)) {
                if (storedData.ACHIEVEMENTS[key])
                    storage.ACHIEVEMENTS[key] = storedData.ACHIEVEMENTS[key]
            };

        storage.ADD_ON = false


        saveToLocaleStorage()


        if (storedData && storedData.lastAwardTime) {
            const secondsToAward = moment().diff(moment(storedData.LAST_AWARD_TIME), "seconds");
            if (secondsToAward > 0) {
                awardCoins(totalEarningPerSec, BigInt(Math.floor(secondsToAward)));
            }
        }
    }
    // console.log("GAME DATA", storage)
}

export function saveToLocaleStorage() {
    let obj = { ...storage, 'COINS': storage.COINS.toString() }
    // console.log(`SAVING ${num && num}`, obj, storage.COINS.toString())
    localStorage.setItem("space_bar_clicker", JSON.stringify(obj))
}

let tempEarn = 0
export function awardCoins(earnedCoins, ratio = 10n) {
    // if (checkFor2Screens()) return;
    // const earnedCoins = totalEarningPerSec.value;
    // earnedCoins *= storage.BOOST_ON ? BigInt(storage.BOOST_NUM) : 1n
    let finalToAdd;
    if (ratio > 10n) {
        finalToAdd = earnedCoins * ratio;
    } else {
        if (earnedCoins < 10n) {
            tempEarn += Number(earnedCoins) / 10
        }
        if (tempEarn >= 1) {
            storage.COINS += BigInt(Math.floor(tempEarn))
            tempEarn = 0
        }
        finalToAdd = (earnedCoins / ratio);
    }
    // console.log('AWARD 1', finalToAdd)
    // finalToAdd *= BigInt(storage.BOOST_NUM)
    // console.log('AWARD 2', finalToAdd)

    storage.COINS += finalToAdd;
    // const nextG = galaxies[storage.GALAXY_IND + 1]
    // if (nextG && BigInt(nextG.distance * 0.3) <= storage.COINS) {
    //         const ind = storage.COINS / BigInt(nextG.distance)
    //         // console.log('AWARD 2', storage.COINS, BigInt(nextG.distance))

    //         planetZoomIn(Number(ind))

    // }
    // checkForCoinsAchievement()
    storage.LAST_AWARD_TIME = moment();
    saveToLocaleStorage()
}
export function buyAlien(key, amount) {
    // amount = BigInt(amount)
    let alien = storage.ALIENS_OWNED[key];
    if (alien.upgradeCost(amount) <= storage.COINS) {
        // if (alien.amount === 0) addAlienOnShip(alien.id)
        storage.COINS -= alien.upgradeCost(amount);
        storage.ALIENS_OWNED[key].amount += amount;
        // checkForCatAchievement(key)
        saveToLocaleStorage()
        // Renderer.drawCat(storage.ALIENS_OWNED[key]);
    } else {
        console.log('ERROR', alien.upgradeCost(), storage.COINS)
    }
}

export const getCoinUrl = () => {
    return '/spacebar-clicker/assets/balls/ball_8.png'
}

export function timerLeft(endTime) {
    const var2 = new Date(endTime) - new Date();

    if (!var2 || var2 <= 0) return "00:00";

    let min = Math.floor(var2 / 60 / 1000)
    min = min < 0 ? 0 : min;
    if (min < 10)
        min = "0" + min;

    let sec = Math.floor(((var2 % 60000) / 1000))
    sec = sec < 0 ? 0 : sec;
    if (sec < 10)
        sec = "0" + sec;

    const res = min + ":" + sec
    return res
}